<article>
  <header class="extra-experience-header">
    <h4 *ngIf="model.name" class="extra-experience-header__name">{{ model.name }}</h4>
    <span *ngIf="model.organization" class="extra-experience-header__org">{{ model.organization }}</span>
  </header>

  <div class="extra-experience-sub">
    <span class="extra-experience-sub__period">
      {{ model.startDate | date: 'MM-yyyy' }} - {{ model.inProgress ? '' : (model.endDate | date: 'MM-yyyy') }}
      <ng-container *ngIf="model.inProgress" i18n>Maintenant</ng-container>
    </span>
  </div>

  <p class="extra-experience-desc">{{ model.description }}</p>
</article>
